<script>
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  props: {
    mainData: {
      type: Array,
      required: true
    },
  },
  watch: {
    mainData () {
      this.getChart()
    }
  },
  data() {
    return {
      chartData: null,
      options: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Hourly Rate'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.getChart()
  },
  methods: {
    async getChart () {
      await this.fillChart()
      await this.renderChart(this.chartData, this.options)
    },
    fillChart () {
      this.chartData = {
        labels: this.mainData.map(n => n.full_name),
        datasets: [
          {
            label: 'Rate Per Hour',
            backgroundColor: '#7bd56e',
            data: this.mainData.map(r => r.hourly_rate)
          }
        ]
      }
    }
  }
}
</script>
